var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product",
      on: {
        mouseenter: function ($event) {
          _vm.image_1 = false
        },
        mouseleave: function ($event) {
          _vm.image_1 = true
        },
      },
    },
    [
      _c("a", { attrs: { href: _vm.get_product_page_url, target: "_blank" } }, [
        _vm.cleaned_product.confidence
          ? _c(
              "div",
              [
                _vm.cleaned_product.confidence >= 90
                  ? [_vm._v("\n        —VERY HIGH—\n      ")]
                  : _vm.cleaned_product.confidence >= 70
                  ? [_vm._v("\n        —HIGH—\n      ")]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.image_1 || !_vm.cleaned_product.img_2,
              expression: "image_1 || !cleaned_product.img_2",
            },
          ],
          attrs: { src: _vm.cleaned_product.img_1 },
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.image_1 && _vm.cleaned_product.img_2,
              expression: "!image_1 && cleaned_product.img_2",
            },
          ],
          attrs: { src: _vm.cleaned_product.img_2 },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "confidence" }, [
          _vm._v(
            "\n      Size: " + _vm._s(_vm.cleaned_product.true_size) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.cleaned_product.title))]),
        _vm._v(" "),
        _c("div", [_vm._v("$" + _vm._s(_vm.cleaned_product.price.toFixed(2)))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }